import { createContext } from "react";
import { RawAgentLiveData, RawAgentTodayData, RawWorkItemData } from "../../models/reports.agents";
import { RawQueueLiveData, RawQueueTodayData } from "../../models/reports.queues";
import { Team } from "../../models/team";

export interface SignalRConnectionHandlers {
  receiveTodaysQueueData(data: RawQueueTodayData): void;
  receiveLiveQueueData(data: RawQueueLiveData): void;
  receiveTodaysAgentData(data: RawAgentTodayData): void;
  receiveLiveAgentData(data: RawAgentLiveData[]): void;
  receiveWorkItemData(data: RawWorkItemData[]): void;
}

export interface SignalRConnectionContextValue {
  subscribe(handlers: Partial<SignalRConnectionHandlers>): string;
  unsubscribe(subscriberId: string): void;
  teams: Team[];
}

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
export const SignalRConnectionContext = createContext<SignalRConnectionContextValue>(undefined!);
